import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin.js'
gsap.registerPlugin(DrawSVGPlugin)

/**
 * HomeHero component.
 * @author Dayne Coulson-Hoffacker
 */
export default class LocationStickyMenu {
  /**
   * Constructs a new LocationStickyMenu component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element

    this.menuItems = this.element.querySelectorAll('.menu-item a')

    const resize = () => {
      const globalHeader = document.querySelector('[data-component="global-header"]')
      if (!globalHeader) return

      const globalHeaderHeight = globalHeader.offsetHeight
      this.element.style.top = `${globalHeaderHeight - 1}px`
    }

    resize()

    window.addEventListener('resize', resize)

    this.menuItems.forEach(menuItem => {
      menuItem.addEventListener('click', (e) => {
        let hashId = menuItem.getAttribute('href')
        if (hashId.startsWith('#')) {
          e.preventDefault()
          hashId = hashId.slice(1)
        } else {
          return true;
        }
        const target = document.getElementById(hashId)
        if (target) {
          let offset = 247
          if (window.innerWidth < 768) {
            offset = 120
          } else if (document.body.classList.contains('admin-bar')) {
            offset += 32
          }
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })

        }
      })
    })

    var locationStickyMenuTL = gsap.timeline({
      paused: true,
      onComplete: () => {
      }
    })

    locationStickyMenuTL.to(this.element, { duration: 1, autoAlpha: 1, ease: 'power2' })

    locationStickyMenuTL.play()
  }
}



// WEBPACK FOOTER //
// ./components/section/location-sticky-menu/index.js